import React from "react";
import OfferForm from "../../forms/OfferForm";

const NewOffer = () => <OfferForm title="Ny Offert" />;

export default NewOffer;
